<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="productId">
        <span slot="label">
          <a-tooltip>
            商品id，关联商品表<template slot="title">商品id，关联商品表</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.productId" :placeholder="$t('请输入')+'商品id，关联商品表'" />
      </a-form-model-item>
      <a-form-model-item prop="productName">
        <span slot="label">
          <a-tooltip>
            产品名称<template slot="title">产品名称</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.productName" :maxLength="255" :placeholder="$t('请输入')+'产品名称'" />
      </a-form-model-item>
      <a-form-model-item prop="productDesc">
        <span slot="label">
          <a-tooltip>
            产品描述<template slot="title">产品描述</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.productDesc" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="quantity">
        <span slot="label">
          <a-tooltip>
            批发数量<template slot="title">批发数量</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.quantity" :placeholder="$t('请输入')+'批发数量'" />
      </a-form-model-item>
      <a-form-model-item prop="productMedia">
        <span slot="label">
          <a-tooltip>
            产品图片/视频(json存储多图、多视频路径)<template slot="title">产品图片/视频(json存储多图、多视频路径)</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="contactName">
        <span slot="label">
          <a-tooltip>
            联系人姓名/公司名<template slot="title">联系人姓名/公司名</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.contactName" :maxLength="128" :placeholder="$t('请输入')+'联系人姓名/公司名'" />
      </a-form-model-item>
      <a-form-model-item prop="contactEmail">
        <span slot="label">
          <a-tooltip>
            邮箱<template slot="title">邮箱</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.contactEmail" :maxLength="128" :placeholder="$t('请输入')+'邮箱'" />
      </a-form-model-item>
      <a-form-model-item prop="contactPhone">
        <span slot="label">
          <a-tooltip>
            手机号<template slot="title">手机号</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.contactPhone" :maxLength="32" :placeholder="$t('请输入')+'手机号'" />
      </a-form-model-item>
      <a-form-model-item prop="country">
        <span slot="label">
          <a-tooltip>
            国家<template slot="title">国家</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.country" :maxLength="64" :placeholder="$t('请输入')+'国家'" />
      </a-form-model-item>
      <a-form-model-item prop="city">
        <span slot="label">
          <a-tooltip>
            城市<template slot="title">城市</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.city" :maxLength="64" :placeholder="$t('请输入')+'城市'" />
      </a-form-model-item>
      <a-form-model-item prop="status">
        <span slot="label">
          <a-tooltip>
            状态 0:待审核 1:已处理 2:已拒绝<template slot="title">状态 0:待审核 1:已处理 2:已拒绝</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="submitTime">
        <span slot="label">
          <a-tooltip>
            提交时间<template slot="title">提交时间</template>
          </a-tooltip>
        </span>
        <a-date-picker style="width: 100%" v-model="form.submitTime" format="YYYY-MM-DD HH:mm:ss" allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="auditTime">
        <span slot="label">
          <a-tooltip>
            审核时间<template slot="title">审核时间</template>
          </a-tooltip>
        </span>
        <a-date-picker style="width: 100%" v-model="form.auditTime" format="YYYY-MM-DD HH:mm:ss" allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="auditUser">
        <span slot="label">
          <a-tooltip>
            审核人id<template slot="title">审核人id</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.auditUser" :placeholder="$t('请输入')+'审核人id'" />
      </a-form-model-item>
      <a-form-model-item prop="auditReason">
        <span slot="label">
          <a-tooltip>
            拒绝原因<template slot="title">拒绝原因</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.auditReason" :maxLength="255" :placeholder="$t('请输入')+'拒绝原因'" />
      </a-form-model-item>
      <a-form-model-item prop="couponId">
        <span slot="label">
          <a-tooltip>
            发放优惠券id<template slot="title">发放优惠券id</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.couponId" :placeholder="$t('请输入')+'发放优惠券id'" />
      </a-form-model-item>
      <a-form-model-item prop="couponCount">
        <span slot="label">
          <a-tooltip>
            发放数量<template slot="title">发放数量</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.couponCount" :placeholder="$t('请输入')+'发放数量'" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getWholesale, addWholesale, updateWholesale } from '@/api/goods/wholesale'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'

export default {
  name: 'CreateForm',
  props: {},
  components: {
    CustomDictTag
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        productId: null,

        productName: null,

        productDesc: null,

        quantity: null,

        productMedia: null,

        contactName: null,

        contactEmail: null,

        contactPhone: null,

        country: null,

        city: null,

        status: 0,

        submitTime: null,

        auditTime: null,

        auditUser: null,

        auditReason: null,

        couponId: null,

        couponCount: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        productId: [
          { required: true, message: '商品id，关联商品表' + this.$t('不能为空'), trigger: 'blur' }
        ],
        productName: [
          { required: true, message: '产品名称' + this.$t('不能为空'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: '状态 0:待审核 1:已处理 2:已拒绝' + this.$t('不能为空'), trigger: 'blur' }
        ],
        submitTime: [
          { required: true, message: '提交时间' + this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        productId: null,
        productName: null,
        productDesc: null,
        quantity: null,
        productMedia: null,
        contactName: null,
        contactEmail: null,
        contactPhone: null,
        country: null,
        city: null,
        status: 0,
        submitTime: null,
        auditTime: null,
        auditUser: null,
        auditReason: null,
        couponId: null,
        couponCount: null
      }

    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getWholesale({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateWholesale(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addWholesale(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
